import type { RouteObject } from "react-router-dom";
import { useParams } from "react-router-dom";
import { CreateAdminPage } from "./pages/CreateAdminPage";
import { EditAdminPage } from "./pages/EditAdminPage";
import { AdminsPage } from "./pages/AdminsPage";
import { useLocale } from "@admin/app/locale";

function AdminAdminsRoute() {
  const locale = useLocale();
  return <AdminsPage locale={locale} />;
}

function AdminCreateRoute() {
  const locale = useLocale();
  return <CreateAdminPage locale={locale} />;
}

function AdminEditRoute() {
  const locale = useLocale();
  const { id = "" } = useParams();
  return <EditAdminPage locale={locale} adminId={id} />;
}

export const adminRoutes: RouteObject[] = [
  {
    path: "admins",
    element: <AdminAdminsRoute />,
  },
  {
    path: "admins/new",
    element: <AdminCreateRoute />,
  },
  {
    path: "admins/:id",
    element: <AdminEditRoute />,
  },
];
